import { key, notify } from '@databases/ping-registry';
import { createColumnSelectionPingEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import {
  SelectionFeatureKeys,
  type SelectionEffectFeature,
} from '../../features/types.ts';
import { isTimelineSelectionFeatureEnabled } from '../utils/is-timeline-selection-feature-enabled.ts';

export function createTimelineColumnSelectionPingEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.TIMELINE_COLUMN_SELECTION_PING_EFFECT,
    type: 'effect',
    isEnabled: isTimelineSelectionFeatureEnabled,
    factory: () =>
      createColumnSelectionPingEffect({
        resolveColumnIndexToFieldId: (columnIndex) => {
          const selectionsApi = getService('SelectionsApi');

          return selectionsApi.resolvePositionToIds(
            { row: { index: 0 }, col: { index: columnIndex } },
            'column',
          ).fieldId;
        },
        notifyColumnSelectionChanged: (fieldId) => {
          notify(key('column', { fieldId }), 'selectionChanged', true);
        },
      }),
  };
}
